import { render } from "./legalVue.vue?vue&type=template&id=3f3f01ef"
const script = {}

import "./legalVue.vue?vue&type=style&index=0&id=3f3f01ef&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__